import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

function detectLocale(): string {
  const raw = (navigator.languages && navigator.languages[0]) || navigator.language || 'en';
  return raw.split('-')[0];
}

async function loadLocale(code: string): Promise<Record<string, any>> {
  try {
    const mod = await import(`./locales/${code}.json`);
    return mod.default || mod;
  } catch {
    const mod = await import(`./locales/en.json`);
    return mod.default || mod;
  }
}

export async function initI18n() {
  const lng = detectLocale();
  const resources: any = {};
  resources[lng] = { translation: await loadLocale(lng) };

  await i18n
    .use(initReactI18next)
    .init({
      lng,
      fallbackLng: 'en',
      resources,
      interpolation: { escapeValue: false }
    });
}

export default i18n;



